// extracted by mini-css-extract-plugin
export default {"content":"xGn0BqDO","topIcon":"ZGcnLkvW","links":"TyekiMIw","telegram":"rBEQSLtf","github":"Jfsk3IR_","email":"MoxDCYJ0"};